<template>
    <div class="flow-menu" ref="tool">
        <div v-for="menu  in  menuList" :key="menu.id">
            <span class="ef-node-pmenu" @click="menu.open = !menu.open"><i :class="{'el-icon-caret-bottom': menu.open,'el-icon-caret-right': !menu.open}"></i>&nbsp;{{menu.name}}</span>
            <ul v-show="menu.open" class="ef-node-menu-ul">
                <draggable @end="end" @start="move" v-model="menu.children" :options="draggableOptions">
                    <li v-for="subMenu in menu.children" class="ef-node-menu-li" :key="subMenu.id" :type="subMenu.type">
                        <i :class="subMenu.ico"></i> {{subMenu.name}}
                    </li>
                </draggable>
            </ul>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';

const mousePosition = {
  left: -1,
  top: -1
};

export default {
  props: {
    templateList: {
      type: Array
    }
  },
  watch: {
    templateList(list) {
      list.forEach((element) => {
        element.ico = 'el-icon-position';
        element.type = element.name;
      });
      this.menuList[1].children = list;
      console.warn(this.menuList);
    }
  },
  data() {
    return {
      activeNames: '1',
      // draggable配置参数参考 https://www.cnblogs.com/weixin186/p/10108679.html
      draggableOptions: {
        preventOnFilter: false,
        sort: false,
        disabled: false,
        ghostClass: 'tt',
        // 不使用H5原生的配置
        forceFallback: true
        // 拖拽的时候样式
        // fallbackClass: 'flow-node-draggable'
      },
      // 默认打开的左侧菜单的id
      defaultOpeneds: ['1', '2'],
      menuList: [
        {
          id: '1',
          type: 'group',
          name: '开始/结束节点',
          ico: 'el-icon-video-pause',
          open: true,
          children: [
            {
              id: '0',
              type: 'end',
              name: '场景开始',
              ico: 'el-icon-caret-right',
              // 自定义覆盖样式
              style: {}
            }, {
              id: '1',
              type: 'over',
              name: '场景结束',
              ico: 'el-icon-caret-left',
              // 自定义覆盖样式
              style: {}
            }, {
              id: '3',
              type: 'user',
              name: '转人工',
              ico: 'el-icon-s-check',
              // 自定义覆盖样式
              style: {}
            }, {
              id: '4',
              type: 'back',
              name: '回原场景',
              ico: 'el-icon-refresh',
              // 自定义覆盖样式
              style: {}
            }
          ]
        },
        {
          id: '2',
          type: 'group',
          name: '作业话术',
          ico: 'el-icon-video-play',
          open: true,
          children: []
        }
      ],
      nodeMenu: {}
    };
  },
  components: {
    draggable
  },
  mounted() {
    this.templateList.forEach((element) => {
      element.ico = 'el-icon-position';
      element.type = element.name;
    });
    this.menuList[1].children = this.templateList;
    console.warn(this.menuList);
  },
  methods: {
    // 根据类型获取左侧菜单对象
    getMenuByType(type) {
      for (let i = 0; i < this.menuList.length; i++) {
        const children = this.menuList[i].children;
        for (let j = 0; j < children.length; j++) {
          if (children[j].type === type) {
            this.nodeMenu = children[j];
          }
        }
      }
    },
    // 拖拽开始时触发
    move(evt, a, b, c) {
      console.warn(c);
      const type = evt.item.attributes.type.nodeValue;
      this.getMenuByType(type);
    },
    // 拖拽结束时触发
    end(evt, e) {
      console.warn(e);
      this.$emit('addNode', evt, this.nodeMenu, mousePosition);
    },
    // 是否是火狐浏览器
    isFirefox() {
      const userAgent = navigator.userAgent;
      if (userAgent.indexOf('Firefox') > -1) {
        return true;
      }
      return false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/engine/ef/node_menu.vue